// components/Blocks/ContactsBlock.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faPlus } from '@fortawesome/free-solid-svg-icons';
import contact_img from '../../../../../../../img/contact.svg';
import ContactPersonForm from './ContactPersonForm';
import RelatedPersonForm from './RelatedPersonForm';

const ContactsBlock = ({ data, onChange, editable, defaultOpen = false, isViewOnly = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleFieldChange = (field, value) => {
    if (isViewOnly) return;
    onChange(field, value);
  };

  const handleRelatedPersonChange = (index, field, value) => {
    if (isViewOnly) return;
    onChange('relatedPerson', { index, field, value });
  };

  const handleRelatedPersonRemove = (index) => {
    if (isViewOnly) return;
    onChange('relatedPersonRemove', index);
  };

  const addRelatedPerson = () => {
    if (isViewOnly) return;
    onChange('addRelatedPerson');
  };

  // Функция для сборки полного имени для показа в свернутом блоке
  const buildFullName = (lastName, firstName, middleName) => {
    const parts = [lastName, firstName, middleName].filter(part => part && part.trim() !== '');
    return parts.join(' ').trim();
  };

  // Подготовка данных для матери - используем раздельные поля из data
  const motherData = {
    lastName: data.motherLastName || '',
    firstName: data.motherFirstName || '',
    middleName: data.motherMiddleName || '',
    phone: data.motherPhone || '',
    email: data.motherEmail || '',
    taxNumber: data.motherIPN || '',
    citizenship: data.motherCitizenship || '',
    address: data.motherAddress || '',
    viber: data.motherViber || ''
  };

  // Подготовка данных для отца - используем раздельные поля из data
  const fatherData = {
    lastName: data.fatherLastName || '',
    firstName: data.fatherFirstName || '',
    middleName: data.fatherMiddleName || '',
    phone: data.fatherPhone || '',
    email: data.fatherEmail || '',
    taxNumber: data.fatherIPN || '',
    citizenship: data.fatherCitizenship || '',
    address: data.fatherAddress || '',
    viber: data.fatherViber || ''
  };

  // Полное имя матери для показа в свернутом блоке
  const motherFullName = buildFullName(motherData.lastName, motherData.firstName, motherData.middleName);
  
  // Полное имя отца для показа в свернутом блоке
  const fatherFullName = buildFullName(fatherData.lastName, fatherData.firstName, fatherData.middleName);

  // Функция для обновления данных матери
  const handleMotherChange = (field, value) => {
    const fieldMap = {
      'lastName': 'motherLastName',
      'firstName': 'motherFirstName', 
      'middleName': 'motherMiddleName',
      'phone': 'motherPhone',
      'email': 'motherEmail',
      'taxNumber': 'motherIPN',
      'citizenship': 'motherCitizenship',
      'address': 'motherAddress',
      'viber': 'motherViber'
    };
    
    if (fieldMap[field]) {
      handleFieldChange(fieldMap[field], value);
    }
  };

  // Функция для обновления данных отца
  const handleFatherChange = (field, value) => {
    const fieldMap = {
      'lastName': 'fatherLastName',
      'firstName': 'fatherFirstName',
      'middleName': 'fatherMiddleName', 
      'phone': 'fatherPhone',
      'email': 'fatherEmail',
      'taxNumber': 'fatherIPN',
      'citizenship': 'fatherCitizenship',
      'address': 'fatherAddress',
      'viber': 'fatherViber'
    };
    
    if (fieldMap[field]) {
      handleFieldChange(fieldMap[field], value);
    }
  };

  return (
    <div className="card-block">
      <button
        className="block-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="left">
          <img className="blk-icon" src={contact_img} alt="" />
          <span className="title">Контактні особи</span>
          {!isOpen && (
            <span className="subtitle">
              {motherFullName} • {fatherFullName}
            </span>
          )}
        </div>
        <FontAwesomeIcon 
          icon={isOpen ? faChevronUp : faChevronDown} 
          className="chevron" 
        />
      </button>
      
      {isOpen && (
        <div className="block-body">
          {/* Блок Мати */}
          <ContactPersonForm
            title="Мати"
            data={motherData}
            onChange={handleMotherChange}
            editable={editable}
            personType="mother"
            isViewOnly={isViewOnly}
          />

          {/* Блок Батько */}
          <ContactPersonForm
            title="Батько"
            data={fatherData}
            onChange={handleFatherChange}
            editable={editable}
            personType="father"
            isViewOnly={isViewOnly}
          />

          {/* Пов'язані особи */}
          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Пов'язані особи</h6>
              {editable && !isViewOnly && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={addRelatedPerson}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-1" />
                  Додати пов'язану особу
                </button>
              )}
            </div>

            {(data.relatedPersons || []).map((person, index) => (
              <RelatedPersonForm
                key={index}
                person={person}
                index={index}
                onChange={handleRelatedPersonChange}
                onRemove={handleRelatedPersonRemove}
                editable={editable}
                isViewOnly={isViewOnly}
              />
            ))}

            {(data.relatedPersons || []).length === 0 && !editable && (
              <div className="text-muted text-center py-3">
                Немає доданих пов'язаних осіб
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactsBlock;